import { api } from './client';
import type { Favorite } from '@/types/domain';

export async function fetchFavorites(): Promise<{ results: Favorite[] }> {
  return api.get('/favorites/me/');
}

export async function addFavorite(specialistSlug: string): Promise<void> {
  await api.post(`/favorites/me/${specialistSlug}/`);
}

export async function removeFavorite(specialistSlug: string): Promise<void> {
  await api.del(`/favorites/me/${specialistSlug}/`);
}
